/**
 * Created by r4zi4l on 25.02.2021
 */

const Map2dAdviceSpeedupLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);
};

Map2dAdviceSpeedupLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceSpeedupLogic.prototype.constructor = Map2dAdviceSpeedupLogic;

Map2dAdviceSpeedupLogic.prototype.findMove = function () {
    let workers = Map2d.currentMap.workers.listBusy();

    if (this.targets) {
        workers = workers.filter(function (worker) {
            return this.targets.some(Unit.Equals.bind(Unit, worker.unit));
        }, this);
    }

    workers.sort((a, b) => a.getTimeLeft() - b.getTimeLeft());

    for (let i = 0; i < workers.length; ++i) {
        const worker = workers[i];

        if (!Buildable.IsBuilt(worker.unit)) {
            return {
                cells: [cc.p(worker.unit.x, worker.unit.y)],
                unitView: ["speedup"]
            };
        }

        const mineable = worker.unit.findComponent(Mineable);
        if (mineable && cleverapps.parseInterval(mineable.getTask().time) !== 0) {
            return {
                cells: [cc.p(worker.unit.x, worker.unit.y)],
                unitView: ["speedup"]
            };
        }
    }
};